export const COMMON_PROPERTIES = {
  ACCESS_TOKEN: "accessToken",
  UPLOAD_DIR: "/uploadfiles/",

  PO_DATE_FORMAT: "DD-MM-YYYY",
  DB_DATE_ONLY_FORMAT: "YYYY-MM-DD",
  DB_DATE_FORMAT: "YYYY-MM-DD HH:mm:ss",
  EXPORT_DATE_FORMAT: "YYYYMMDD-HHmmss",
  FORM_DATE_FORMAT: "yyyy-MM-dd",
  FORM_DATEMONTH_FORMAT: "MMM-yyyy",
  FORM_DATETIME_FORMAT: "yyyy-MM-dd HH:mm:ss",
  PDF_WATERMARK_TITLE: "CHAKRA",
  DELETE_MSG: "Are you sure you want to delete ",
  COMPLETE_MSG: "Are you sure you want to Complete ",
  REJECT_MSG: "Are you sure you want to Reject ",
  SUBMIT_MSG: "Are you sure you want to Submit ",
  LOG_IN_SUCCESS_MSG: "User Logged in successfully.",
  LOG_IN_FAILED_MSG: "User Log in failed.",
  LOG_IN_REFRESH_FAILURE_MSG: "User refresh failed.",
  LOG_IN_REFRESH_SUCCESS_MSG: "User refreshed successfully.",
  LOG_OUT_SUCCESS_MSG: "You're successfully logged out.",
  LOG_OUT_FAILURE_MSG: "Log out failed.",
  EMAIL_LABEL: "e-mail",
  PROFILE_CHECK_BOX_ENABLE: "Please enable the checkbox state and then Update",
  EXPENDITURE_STATUS_MESSAGE_ENABLE: "Recording Monthly Receipts & Expenditures was completed",
  INFORMATION: "Information",
};

export const EXPORT_PROPERTIES = {
  DISPLAY_DATE_FORMAT: "YYYY-MM-DD HH:mm:ss",
  WHITE_COLOR_CODE: "#FFFFFF",
  WHITE_COLOR_HEX_CODE: "0XFFFFFF",
  EXPORT_HEADER_ROW_COLOR: "0XFFFFFF",
  EXPORT_EVEN_ROW_COLOR: "0XFFFFFF",
  EXPORT_ODD_ROW_COLOR: "0XFFFFFF",
  EXPORT_EXCEL_FONT_TYPE: "Calibri-Regular",
  EXPORT_DATE_TIME_FORMAT: "dd-MM-yyyy HH:mm:ss",
  EXPORT_FILE_DATE_TIME_FORMAT: "ddMMyyyy-HHmmss",
  EXPORT_TABLE_COLORS: "0X49B6F1,0XEBF2FA,0XFFFFFF",
  EXPORT_WATER_MARK_REQUIRED: "false",
  EXPORT_WATER_MARK_CONTENT: "CHAKRA NETWORK SOLUTIONS",
  EXPORT_LOGO_REQUIRED: "false",
  EXPORT_EXCEL_FILE_EXTENSION: ".xls",
};

export const COMPLIANCE_PROPERTIES = {
  COMPANY_LIST_TITLE: "Choose Company",
  DIRECTOR_LIST_TITLE: "Choose Director",
  COFOUNDER_LIST_TITLE: "Choose Co-Founder",
  ACTIONLABEL: "Company",

  BASIC_INFO_TITLE: "Basic Info",
  BASIC_INFO_SHARE_TITLE: "Company Shares",
  DIPP_TITLE: "DPIIT (Formerly DIPP)",
  GST_TITLE: "GST",
  UAN_TITLE: "UAN",
  BOARD_OF_DIRECTORS_TITLE: "Board of Directors",

  DIR_3_KYC_TITLE: "DIR 3 KYC",
  STATUTORY_FILING_TITLE: "Statutory Register",
  PROMOTERS_DETAILS_TITLE: "Promoters Details",
  COFOUNDER_SHAREHOLDINGS_TITLE: "Co founders Shareholding",
  COFOUNDER_AGREEMENT_TITLE: "Co founders Agreement",
  DISCLOSURE_INTEREST_TITLE: "Disclosure of Interest",

  BOARD_MEETING_TITLE: "Board Meetings",
  AGM_TITLE: "Annual General Meeting",

  APPOINTMENT_OF_AUDITOR_TITLE: "Appointment of Auditor",
  INC_20_A_TITLE: "INC - 20A",

  AOC_4_TITLE: "AOC - 4",
  MGT_7_TITLE: "MGT - 7",
  MSME_TITLE: "MSME - 1",
  DPT_3_TITLE: "DPT - 3",
  APPOINTMENT_OF_CS_TITLE: "Appointment of CS",
  PAYMENT_SERVICE_TITLE: "Payment Terms",
  PAYMENT_OF_TDS_TITLE: "Payment of T.D.S",
  FILING_OF_TDS_RETURN_TITLE: "Filing of T.D.S Return",
  FILING_OF_INCOME_TAX_RETURN_TITLE: "Filing of Income Tax Return",
  PAYMENT_OF_ADVANCE_TAX_TITLE: "Payment of Advance Tax",
  PAYMENT_OF_ESIPF_TITLE: "Payment of ESI/ PF",
  PAYMENT_OF_PROFESSIONAL_TAX_TITLE: "Payment of Professional Tax",
  GSTR_1_TITLE: "GSTR – 1",
  GSTR_3B_TITLE: "GSTR – 3B",
  GSTR_9_TITLE: "GSTR – 9",
  PURCHASE_FORM_TITLE: "Purchase Requisition",
  PURCHASE_DETAILS_TITLE: "Purchase Details",
  PURCHASE_ORDER_TITLE: "Purchase Order",
  GOOD_INWARD_PURCHASE_ORDER_TITLE: "Goods Inward Form",
  PURCHASE_PRODUCT_TITLE: "Product",
  PURCHASE_SERVICE_TITLE: "Service",
  CUST_TITLE: "Customer",
  VEN_TITLE: "Vendor",
  INVENT_RAW_TITLE: "Raw Materials",
  INVENT_PDT_TITLE: "Finished Products",
  GOODINWARD_FORM_TITLE: "Goods Inward Form",
  TERMS_TITLE: "Terms and Conditions Template",
};

export const NEPROFILENAMES_PROPERTIES = {
  TITLE: "NE Profiles",
};

export const DEFAULTNEPROFILENAMES_PROPERTIES = {
  TITLE: "Default NE Profiles",
};

export const USERDETAILS_PROPERTIES = {
  TITLE: "User Details",
  ACTIONLABEL: "User Details",
  EXPORT_FILE_NAME: "UserDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const GUIUSERPROFILE_PROPERTIES = {
  TITLE: "GUI User Profile",
  ACTIONLABEL: "GUI User Profile Details",
  EXPORT_FILE_NAME: "GUI UserProfileDetails-",
};

export const NEUSERPROFILE_PROPERTIES = {
  TITLE: "NE Profile",
  ACTIONLABEL: "NE Profile Details",
  EXPORT_FILE_NAME: "GUI ProfileDetails-",
};

export const DEFAULTNEUSERPROFILE_PROPERTIES = {
  TITLE: "Default NE Privileges",
  ACTIONLABEL: "Default NE Privileges",
  EXPORT_FILE_NAME: "Default NE Privileges-",
};

export const PROFILEDETAILS_PROPERTIES = {
  TITLE: "Profile Details",
  ACTIONLABEL: "Profile Details",
  EXPORT_FILE_NAME: "ProfileDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const NEPROFILEDETAILS_PROPERTIES = {
  TITLE: "NE Profile Details",
  ACTIONLABEL: "NE Profile Details",
  EXPORT_FILE_NAME: "NE ProfileDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const APPSINPROFILES_PROPERTIES = {
  TITLE: "Applications",
  ACTIONLABEL: "Applications",
  EXPORT_FILE_NAME: "Applications-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const NEAPPSINPROFILES_PROPERTIES = {
  TITLE: "NE Applications",
  ACTIONLABEL: "NE Applications",
  EXPORT_FILE_NAME: "NE Applications-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const AUDITLOG_PROPERTIES = {
  TITLE: "Audit Logs",
  ACTIONLABEL: "Audit Logs",
  EXPORT_FILE_NAME: "AuditLogs-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const LOGINDETAILS_PROPERTIES = {
  TITLE: "Login Details",
  ACTIONLABEL: "Login Details",
  EXPORT_FILE_NAME: "LoginDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};
export const COMPANYDETAILS_PROPERTIES = {
  TITLE: "Company Details",
  ACTIONLABEL: "Company Details",
  EXPORT_FILE_NAME: "CompanyDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};
export const AGENT_DETAILS_PROPERTIES = {
  TITLE: "Contractor Details",
  ACTIONLABEL: "Contractor Details",
  EXPORT_FILE_NAME: "ContractorDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};
export const BANK_ACCOUNT_DETAILS_PROPERTIES = {
  TITLE: "Bank Account Details",
  ACTIONLABEL: "Bank Account Details",
  EXPORT_FILE_NAME: "BankAccountDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const AGENT_DOCUMENT_DETAILS_PROPERTIES = {
  TITLE: "Contractor's Documents Detail",
  ACTIONLABEL: "Contractor's Documents Detail",
  EXPORT_FILE_NAME: "Contractor's Documents Detail",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const LABOUR_DETAILS_PROPERTIES = {
  TITLE: "Employee Details",
  ACTIONLABEL: "Employee Details",
  EXPORT_FILE_NAME: "EmployeeDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};
export const LABOUR_DOCUMENT_DETAILS_PROPERTIES = {
  TITLE: "Employee's Document Details",
  ACTIONLABEL: "Employee's Document Details",
  EXPORT_FILE_NAME: "Employee's Document Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const CASH_DISPENSER_DETAILS_PROPERTIES = {
  TITLE: "Cash Dispenser Details",
  ACTIONLABEL: "Cash Dispenser Details",
  EXPORT_FILE_NAME: "CashDispenserDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};
export const CASH_DISPENSER_DOCUMENT_DETAILS_PROPERTIES = {
  TITLE: "Cash Dispenser Document Details",
  ACTIONLABEL: "Cash Dispenser Document Details",
  EXPORT_FILE_NAME: "CashDispenserDetails",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const COMPANY_PAYMENT_DETAILS = {
  TITLE: "Contractor Payment Details",
  ACTIONLABEL: "Contractor Payment Details",
  EXPORT_FILE_NAME: "ContractorPayentDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};
export const COMPANY_PAYMENT_EXCEL_DETAILS_DOCUMENT = {
  TITLE: "Company Payment Document Details",
  ACTIONLABEL: "Company Payment Document Details",
  EXPORT_FILE_NAME: "CompanyPaymentDocumentDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const LABOUR_PAYMENT_DETAILS = {
  TITLE: "Employee Payment Details",
  ACTIONLABEL: "Employee Payment Details",
  EXPORT_FILE_NAME: "EmployeePaymentDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const LEDGER_DETAILS = {
  TITLE: "Ledger Details",
  ACTIONLABEL: "Ledger Details",
  EXPORT_FILE_NAME: "LedgerDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};
export const DOCUMENTDETAILS_PROPERTIES = {
  TITLE: "Document Details",
  ACTIONLABEL: "Document Details",
  EXPORT_FILE_NAME: "DocumentDetails-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};
//new
export const CASHDISPENSINGFEE_PROPERTIES = {
  TITLE: "Cash Dispensing Fee",
  ACTIONLABEL: "Cash Dispensing Fee",
  EXPORT_FILE_NAME: "CashDispensingFee-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const EMPLOYEEPREFERENCES_PROPERTIES = {
  TITLE: "Employee Preferences",
  ACTIONLABEL: "Employee Preferences",
  EXPORT_FILE_NAME: "EmployeePreferences-",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};
export const AGAMI_PAYMENT_DETAILS = {
  TITLE: "Agami Payments & Reconciliation for the Pay Period",
  ACTIONLABEL: "Agami Payments & Reconciliation for the Pay Period",
  EXPORT_FILE_NAME: "Agami_Payments_Reconciliation_for_the_Pay_Period",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const ACCOUNT_TRANSACTION = {
  TITLE: "Pending account Transaction Details",
  ACTIONLABEL: "Pending account Transaction Details",
  EXPORT_FILE_NAME: "Pending account-Transaction-Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const ACCOUNT_TRANSACTION_INPROGRESS = {
  TITLE: "Account Transactions Inprogress",
  ACTIONLABEL: "Account Transactions Inprogress",
  EXPORT_FILE_NAME: "Account-Transactions-Inprogress",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const ACCOUNT_TRANSACTION_HISTORY = {
  TITLE: "Account Transaction History",
  ACTIONLABEL: "Account Transaction History",
  EXPORT_FILE_NAME: "Account-Transaction-History",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const MOBILE_RECHARGE_PENDING = {
  TITLE: "Mobile Recharge Pending",
  ACTIONLABEL: "Mobile Recharge Pending",
  EXPORT_FILE_NAME: "Mobile-Recharge-Pending",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const MOBILE_RECHARGE_HISTORY = {
  TITLE: "Mobile Recharge History",
  ACTIONLABEL: "Mobile Recharge History",
  EXPORT_FILE_NAME: "Mobile-Recharge-History",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const SERVICES = {
  TITLE: "Services",
  ACTIONLABEL: "Services",
  EXPORT_FILE_NAME: "Services",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const SERVICE_PROVIDERS = {
  TITLE: "Service Providers",
  ACTIONLABEL: "Service Providers",
  EXPORT_FILE_NAME: "Service-Providers",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const SERVICE_TYPES = {
  TITLE: "Service Types",
  ACTIONLABEL: "Service Types",
  EXPORT_FILE_NAME: "Service-Types",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const SERVICE_DETAILS = {
  TITLE: "Service Details",
  ACTIONLABEL: "Service Details",
  EXPORT_FILE_NAME: "Service-Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const EMPLOYEE_EXCEL_IMPORT_DETAILS = {
  TITLE: "Employee Bulk Import Details",
  ACTIONLABEL: "Employee Bulk Import Details",
  EXPORT_FILE_NAME: "EmployeeBulkImportDetails",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EMPLOYEE_DETAILS = {
  TITLE: "Employee Details",
  ACTIONLABEL: "Employee Details",
  EXPORT_FILE_NAME: "EmployeeBulkImportDetails",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const UNIVERSITY_DETAILS = {
  TITLE: "University Details",
  ACTIONLABEL: "University Details",
  EXPORT_FILE_NAME: "Universities",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ACADEMIC_INSTITUTES_DETAILS = {
  TITLE: "Academic Institute Details",
  ACTIONLABEL: "Academic Institute Details",
  EXPORT_FILE_NAME: "Academic_Institutes",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",

}

export const ZO_DETAILS = {
  TITLE: "ZO/S-ZO/RPO Office with Jurisdiction",
  ACTIONLABEL: "ZO/S-ZO/RPO Office with Jurisdiction",
  EXPORT_FILE_NAME: "ZO/S-ZO/RPO Office with Jurisdiction",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",

}

export const RO_DETAILS = {
  TITLE: "ZO/S-ZO/RPO Office Details",
  ACTIONLABEL: "ZO/S-ZO/RPO Office Details",
  EXPORT_FILE_NAME: "ZO/S-ZO/RPO_Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",

}

export const SCHOLARSHIPS = {
  TITLE: "Scholarship Details",
  ACTIONLABEL: "Scholarship Details",
  EXPORT_FILE_NAME: "Scholarships_Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",

}

export const COURSE_DETAILS = {
  TITLE: "Course Details",
  ACTIONLABEL: "Course Details",
  EXPORT_FILE_NAME: "Course_Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",

}

export const COURSE_FEES = {
  TITLE: "Course Fees",
  ACTIONLABEL: "Course Fees",
  EXPORT_FILE_NAME: "Course_Fees",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",

}

export const STUDENT_DETAILS = {
  TITLE: "Student Details",
  ACTIONLABEL: "Student Details",
  EXPORT_FILE_NAME: "Student Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",

}

export const STUDENT_ATTENDANCE_REPORT_TRACK = {
  TITLE: "Track Student's Attendance Report",
  ACTIONLABEL: "Track Student's Attendance Report",
  EXPORT_FILE_NAME: "TrackStudentAttendanceReport",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const UNIVERSITY_PAYMENT = {
  TITLE: "Payment Receipt Confirmation",
  ACTIONLABEL: "Payment  Receipt Confirmation",
  EXPORT_FILE_NAME: "Receipt_Confirmation",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_PAYMENT = {
  TITLE: "Student Payment",
  ACTIONLABEL: "Student Payment",
  EXPORT_FILE_NAME: "Student_Payment",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const ACADEMIC_PAYMENT_RELEASE = {
  TITLE: "Academic Payment Release",
  ACTIONLABEL: "Academic Payment Release",
  EXPORT_FILE_NAME: "Academic_Payment_Release",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const STUDENT_PAYMENT_RELEASE = {
  TITLE: "Student Payment Release",
  ACTIONLABEL: "Student Payment Release",
  EXPORT_FILE_NAME: "Student_Payment_release",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const INSTITUTE_PAYMENT_DETAILS = {
  TITLE: "Institute Payment Details",
  ACTIONLABEL: "Institute Payment Details",
  EXPORT_FILE_NAME: "Institute_Payment_Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_PAYMENT_DETAILS = {
  TITLE: "Student Payment Details",
  ACTIONLABEL: "Student Payment Details",
  EXPORT_FILE_NAME: "Student_Payment_Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const SCHEME_WISE_EXPENDITURE = {
  TITLE: "Scheme Wise Expenditure",
  ACTIONLABEL: "Scheme Wise Expenditure",
  EXPORT_FILE_NAME: "Scheme Wise Expenditure",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const STUDENT_LIVE_STATUS = {
  TITLE: "Status of students studying under various scholarship schemes",
  ACTIONLABEL: "Status of students studying under various scholarship schemes",
  EXPORT_FILE_NAME: "Status of students studying under various scholarship schemes",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const LIVE_FORMAT = {
  TITLE: "Detail of Live Students studying under various scholarship scheme.",
  ACTIONLABEL: "Detail of Live Students studying under various scholarship scheme.",
  EXPORT_FILE_NAME: "STUDENTS_LIVE_Format",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_ACADEMIC_REPORT_TRACK = {
  TITLE: "Track Student's Academic Report",
  ACTIONLABEL: "Track Student's Academic Report",
  EXPORT_FILE_NAME: "TrackStudentAcademicReport",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
};

export const STUDENT_PAYMENT_BULK_IMPORT = {
  TITLE: "Student Payment Bulk Import",
  ACTIONLABEL: "Student Payment Bulk Import",
  EXPORT_FILE_NAME: "Student Payment Bulk Import",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ACADEMIC_PAYMENT_BULK_IMPORT = {
  TITLE: "Academic Institutes Payment Bulk Import",
  ACTIONLABEL: "Academic Institutes Payment Bulk Import",
  EXPORT_FILE_NAME: "Academic Institutes Payment Bulk Import",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_EXPENDITURE_REPORT = {
  TITLE: "Expenditure Report/Reference Sheet",
  ACTIONLABEL: "Expenditure Report/Reference Sheet",
  EXPORT_FILE_NAME: "Reference Sheet",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const REPORT_EXPENDITURE = {
  TITLE: "Month Wise Expenditure",
  ACTIONLABEL: "Month Wise Expenditure",
  EXPORT_FILE_NAME: "Month Wise Expenditure",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_EXPENDITURE_SUMMARY = {
  TITLE: "Student Expenditure Summary",
  ACTIONLABEL: "Student Expenditure Summary Import",
  EXPORT_FILE_NAME: "Student Expenditure",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EX_INDIA_STUDENT_DETAILS = {
  TITLE: "Ex-Indian Student Attendance details",
  ACTIONLABEL: "Ex-Indian Student Attendance details",
  EXPORT_FILE_NAME: "Ex-Indian Student",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_LEDGER = {
  TITLE: "Report Format of student-wise / Financial Year-wise Legder",
  ACTIONLABEL: "Report Format of student-wise / Financial Year-wise Legder",
  EXPORT_FILE_NAME: "Student_Ledger",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_PAYMENT_PROCESS_PENDING = {
  TITLE: "Payment Process Pending",
  ACTIONLABEL: "Payment Process Pending",
  EXPORT_FILE_NAME: "Payment_Process_Pending",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const STUDENT_PAYMENT_PROCESS_APPROVED = {
  TITLE: "Payment Process Approved",
  ACTIONLABEL: "Payment Process Approved",
  EXPORT_FILE_NAME: "Payment_Process_Approved",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_PAYMENT_PROCESS_COMPLETED = {
  TITLE: "Payment Process Completed",
  ACTIONLABEL: "Payment Process Completed",
  EXPORT_FILE_NAME: "Payment_Process_Completed",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_PAYMENT_PROCESS_CANCELLED = {
  TITLE: "Cancelled/Rejected/Annulled",
  ACTIONLABEL: "Cancelled/Rejected",
  EXPORT_FILE_NAME: "Cancelled/Rejected",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const INSTITUTE_PAYMENT_PROCESS = {
  TITLE: "Process Institute Payment",
  ACTIONLABEL: "Process Institute Payment",
  EXPORT_FILE_NAME: "Process_Institute_Payment",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_DOCUMENT_APPROVAL = {
  TITLE: "Student Document Approval",
  ACTIONLABEL: "Student Document Approval",
  EXPORT_FILE_NAME: "Student Document Approval",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}


export const STUDENT_DOCUMENT_APPROVED_REPORT = {
  TITLE: "Student Document Approved Report",
  ACTIONLABEL: "Student Document Approved Report",
  EXPORT_FILE_NAME: "Student Document Approved Report",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const JOINING_REPORT = {
  TITLE: "JOINING REPORT OF THE STUDENT FOR THE ACADEMIC YEAR",
  ACTIONLABEL: "JOINING REPORT OF THE STUDENT FOR THE ACADEMIC YEAR",
  EXPORT_FILE_NAME: "Joining_report",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const TERMINATION_OF_SCHOLARSHIP = {
  TITLE: "TERMINATION OF SCHOLARSHIP",
  ACTIONLABEL: "TERMINATION OF SCHOLARSHIP",
  EXPORT_FILE_NAME: "Termination of Scholarship",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_ACCOMADATION_APPROVAL = {
  TITLE: "Student Accommodation Approval",
  ACTIONLABEL: "Student Accommodation Approval",
  EXPORT_FILE_NAME: "Student Accommodation Approval",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}


export const STUDENT_ACCOMADATION_APPROVED_REPORT = {
  TITLE: "Student Accommodation Approved Report",
  ACTIONLABEL: "Student Accommodation Approved Report",
  EXPORT_FILE_NAME: "Student Accommodation Approved Report",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const COURSE_FEES_DETAILS = {
  TITLE: "Course Fees Details Processed",
  ACTIONLABEL: "TERMINATION OF SCHOLARSHIP",
  EXPORT_FILE_NAME: "Termination of Scholarship",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const RECORD_STUDENT_WELFARE = {
  TITLE: "Record Student Welfare",
  ACTIONLABEL: "Record Student Welfare Import",
  EXPORT_FILE_NAME: "Record Student Welfare",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_WELFARE_REPORT = {
  TITLE: "Student Welfare Report",
  ACTIONLABEL: "Student Welfare Report",
  EXPORT_FILE_NAME: "Student Welfare Report",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_AIRTICKET_PAYMENT_RELEASE = {
  TITLE: "Student AirTicket Payment Release",
  ACTIONLABEL: "Student AirTicket Payment Release",
  EXPORT_FILE_NAME: "Student_AirTicket_release",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STUDENT_COURSE_DEPARTMENT_DETAILS = {
  TITLE: "Student Course Department Details",
  ACTIONLABEL: "Student Course Department Details",
  EXPORT_FILE_NAME: "Student Course Department Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ARTIST_MANAGEMENT = {
  TITLE: "Artist Management System",
  ACTIONLABEL: "Artist Management System",
  EXPORT_FILE_NAME: "Artist Management System",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const EDIT_ARTIST_DETAILS = {
  TITLE: "Edit Artist Details",
  ACTIONLABEL: "Edit Artist Details",
  EXPORT_FILE_NAME: "Edit Artist Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}


export const BUDGET_ALLOCATION = {
  TITLE: "Budget Allocation",
  ACTIONLABEL: "Budget Allocation",
  EXPORT_FILE_NAME: "Budget Allocation",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const BUDGET_HEADS = {
  TITLE: "Budget Heads",
  ACTIONLABEL: "Budget Heads",
  EXPORT_FILE_NAME: "Budget Heads",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const CONTACTS = {
  TITLE: "Contacts",
  ACTIONLABEL: "Contacts",
  EXPORT_FILE_NAME: "Contacts",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ENTITY = {
  TITLE: "Entity",
  ACTIONLABEL: "Entity",
  EXPORT_FILE_NAME: "Entity",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ENTITY_PERFORMANCE = {
  TITLE: "Entity Performance",
  ACTIONLABEL: "Entity Performance",
  EXPORT_FILE_NAME: "Entity Performance",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ENTITY_TYPES = {
  TITLE: "Entity Types",
  ACTIONLABEL: "Entity Types",
  EXPORT_FILE_NAME: "Entity Types",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_COMP_STATUS = {
  TITLE: "Event Completion Status",
  ACTIONLABEL: "Event Completion Status",
  EXPORT_FILE_NAME: "Event Completion Status",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_COST = {
  TITLE: "Event Cost",
  ACTIONLABEL: "Event Cost",
  EXPORT_FILE_NAME: "Event Cost",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_DETAILS = {
  TITLE: "Event Details",
  ACTIONLABEL: "Event Details",
  EXPORT_FILE_NAME: "Event Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_PROCESSINGS = {
  TITLE: "Event Processing",
  ACTIONLABEL: "Event Processing",
  EXPORT_FILE_NAME: "Event Processing",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_REQUEST = {
  TITLE: "Event Request",
  ACTIONLABEL: "Event Request",
  EXPORT_FILE_NAME: "Event Request",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_TYPE = {
  TITLE: "Event Type",
  ACTIONLABEL: "Event Type",
  EXPORT_FILE_NAME: "Event Type",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const INVENTORY = {
  TITLE: "Inventory",
  ACTIONLABEL: "Inventory",
  EXPORT_FILE_NAME: "Inventory",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const INVENTORY_LIST = {
  TITLE: "Inventory List",
  ACTIONLABEL: "Inventory List",
  EXPORT_FILE_NAME: "Inventory List",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const INVENTORY_REPORT = {
  TITLE: "Inventory Report",
  ACTIONLABEL: "Inventory Report",
  EXPORT_FILE_NAME: "Inventory Report",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STAFF = {
  TITLE: "Staff Details",
  ACTIONLABEL: "Staff",
  EXPORT_FILE_NAME: "Staff",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const STAFF_TYPE = {
  TITLE: "Staff Type",
  ACTIONLABEL: "Staff Type",
  EXPORT_FILE_NAME: "Staff Type",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const COUNTRY = {
  TITLE: "Country",
  ACTIONLABEL: "Country",
  EXPORT_FILE_NAME: "Country",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ARTIST_MANAGEMENT_COUNTRY = {
  TITLE: "Country Visited",
  ACTIONLABEL: "Country Visited",
  EXPORT_FILE_NAME: "Country Visited",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ENTITY_PERFORMANCE_CATEGORY = {
  TITLE: "Entity Performance Category",
  ACTIONLABEL: "Entity Performance Category",
  EXPORT_FILE_NAME: "Entity Performance Category",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const INVENTORY_CATEGORY = {
  TITLE: "Inventory Category",
  ACTIONLABEL: "Inventory Category",
  EXPORT_FILE_NAME: "Inventory Category",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_DETAILS_CATEGORY = {
  TITLE: "Event Details Category",
  ACTIONLABEL: "Event Details Category",
  EXPORT_FILE_NAME: "Event Details Category",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ARTIST_CATEGORY = {
  TITLE: "Artist Category",
  ACTIONLABEL: "Artist Category",
  EXPORT_FILE_NAME: "Artist Category",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ARTIST_GENRE = {
  TITLE: "Artist Genre",
  ACTIONLABEL: "Artist Genre",
  EXPORT_FILE_NAME: "Artist Genre",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const COMPONENT_PROPERTIES = {
  HELP_BUTTON_LABEL: "HELP_BUTTON",
  UPDATE_BUTTON_LABEL: "UPDATE_BUTTON",
  ADD_BUTTON_LABEL: "ADD_BUTTON",
  REFRESH_BUTTON_LABEL: "REFRESH_BUTTON",
  SAVE_BUTTON_LABEL: "SAVE_BUTTON",
  POST_BUTTON_LABEL: "POST_BUTTON",
  PRINT_BUTTON_LABEL: "PRINT_BUTTON",
  APPROVAL_BUTTON_LABEL: "APPROVAL_BUTTON",
  DOWNLOAD_BUTTON_LABEL: "DOWNLOAD_BUTTON",
};

export const ARTIST_LIST = {
  TITLE: "Artist List",
  ACTIONLABEL: "Artist List",
  EXPORT_FILE_NAME: "Artist List",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}



export const CULTURAL_FACT_SHEET = {
  TITLE: "Cultural Fact Sheet",
  ACTIONLABEL: "Cultural Fact Sheet",
  EXPORT_FILE_NAME: "Cultural Fact Sheet",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_REQUEST_TRAILS = {
  TITLE: "Event Request Trails",
  ACTIONLABEL: "Event Request Trails",
  EXPORT_FILE_NAME: "Event Request Trails",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ARTIST_DETAILS = {
  TITLE: "Artist Associations",
  ACTIONLABEL: "Artist Associations",
  EXPORT_FILE_NAME: "Artist Associations",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_REQUEST_REPORT = {
  TITLE: "Event Request Report",
  ACTIONLABEL: "Event Request Report",
  EXPORT_FILE_NAME: "Event Request Report",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_REQUEST_EXPENDITURES = {
  TITLE: "Event Expenditures",
  ACTIONLABEL: "Event Expenditures",
  EXPORT_FILE_NAME: "EventExpenditures",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const HANDING_OVER_ROLES = {
  TITLE: "Handing Over Roles",
  ACTIONLABEL: "Handing Over Roles",
  EXPORT_FILE_NAME: "Handing Over Roles",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const HANDING_OVER_REPORT = {
  TITLE: "Handing Over Report",
  ACTIONLABEL: "Handing Over Report",
  EXPORT_FILE_NAME: "Handing Over Report",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const CONFIGURATIONS = {
  TITLE: "Configurations",
  ACTIONLABEL: "Configurations",
  EXPORT_FILE_NAME: "Configurations",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const MISSION_TO_ICCS = {
  TITLE: "Assigning Mission to ICCs",
  ACTIONLABEL: "Assigning Mission to ICCs",
  EXPORT_FILE_NAME: "Assigning Mission to ICCs",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const SURVEY_QUESTIONS = {
  TITLE: "ICC Monthly Performance Survey",
  ACTIONLABEL: "ICC Monthly Performance Survey",
  EXPORT_FILE_NAME: "ICC Monthly Performance Survey",
  PAGESIZE: "40",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ARTIST_GROUPS = {
  TITLE: "Artist Groups",
  ACTIONLABEL: "Artist Groups",
  EXPORT_FILE_NAME: "Artist Groups",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ARTIST_GROUP_ASSOCIATIONS = {
  TITLE: "Artist Group Associations",
  ACTIONLABEL: "Artist Group Associations",
  EXPORT_FILE_NAME: "Artist Group Associations",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ARTISTS_DETAILS = {
  TITLE: "Artists Details",
  ACTIONLABEL: "Artists Details",
  EXPORT_FILE_NAME: "Artists Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}


export const RECORD_MONTHLY_RECEIPT_EXPENDITURE = {
  TITLE: "Monthly Receipt & Expenditure",
  ACTIONLABEL: "Monthly Receipt & Expenditure",
  EXPORT_FILE_NAME: "Monthly Receipt & Expenditure",
  PAGESIZE: "50",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ENTITY_CONTIENTS_ASSOCIATION = {
  TITLE: "Entity Division Associations",
  ACTIONLABEL: "Entity Division Associations",
  EXPORT_FILE_NAME: "Entity Division Associations",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const DIVISIONS = {
  TITLE: "Divisions",
  ACTIONLABEL: "Divisions",
  EXPORT_FILE_NAME: "Divisions",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const SUB_DIVISIONS = {
  TITLE: "Sub Divisions",
  ACTIONLABEL: "Sub Divisions",
  EXPORT_FILE_NAME: "Sub Divisions",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const NOTIFY_NEAR_BY_ENTITY = {
  TITLE: "Notify Near by Entity",
  ACTIONLABEL: "Notify Near by Entity",
  EXPORT_FILE_NAME: "Notify Near by Entity",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const NEW_EVENT_REQUEST_VIEW = {
  TITLE: "Event Request",
  ACTIONLABEL: "Event Request",
  EXPORT_FILE_NAME: "Event Request",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const EXPENDITURE_DETAILS = {
  TITLE: "Voucher Details",
  ACTIONLABEL: "Voucher Details",
  EXPORT_FILE_NAME: "Voucher Details",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const RANKING_DETAILS = {
  TITLE: "Performance Survey Ranking Table View",
  ACTIONLABEL: "Performance Survey Ranking Table View",
  EXPORT_FILE_NAME: "Performance Survey Rank",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const GUIDELINES_FOR_ENTITY = {
  TITLE: "Guidelines for Entity",
  ACTIONLABEL: "Guidelines for Entity",
  EXPORT_FILE_NAME: "Guidelines for Entity",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ARTISTS_GENRE_STS_REPORTS = {
  TITLE: "Artists Genre type Status",
  ACTIONLABEL: "Artists Genre type Status",
  EXPORT_FILE_NAME: "Artists Genre Type",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const ARTISTS_GENRE_CAT_COUNT_REPORTS = {
  TITLE: "Artist Genre, Category",
  ACTIONLABEL: "Artist Genre, Category",
  EXPORT_FILE_NAME: "Artist Genre, Category",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const ARTISTS_GENRE_CAST_STS_REPORTS = {
  TITLE: "Artist Genre, Category Status",
  ACTIONLABEL: "Artist Genre, Category Status",
  EXPORT_FILE_NAME: "ArtistGenreCategory sts",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const AIMS_OVERALL_REPORT = {
  TITLE: "Overall Report",
  ACTIONLABEL: "Overall Report",
  EXPORT_FILE_NAME: "AIMSOverallReport",
  PAGESIZE: "50",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const AIMS_EXPENSE_RECEIPT_DASHBOARD = {
  TITLE: "Expense and Receipt Dashboard",
  ACTIONLABEL: "Expense and Receipt Dashboard",
  EXPORT_FILE_NAME: "AIMSExpenseAndReceiptDashboard",
  PAGESIZE: "50",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const MONTHLY_EXPENDITURE_REPORT = {
  TITLE: "Expenditure Report",
  ACTIONLABEL: "Expenditure Report",
  EXPORT_FILE_NAME: "Expenditure Report",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const MONTHLY_EXPENDITURE_GRAPH = {
  TITLE: "Expenditure Graph Report",
}

export const MONTHLY_RECEIPT_REPORT = {
  TITLE: "Receipt Report",
  ACTIONLABEL: "Receipt Report",
  EXPORT_FILE_NAME: "Receipt Report",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const MONTHLY_RECEPT_GRAPH = {
  TITLE: "Receipt Graph Report",
}

export const INDIAN_STATES_UNION_TERRITORIES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman & Diu",
  "The Government of NCT of Delhi",
  "Jammu & Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
]

export const ARTIST_PREVIOUS_SPONSES_REPORT = {
  TITLE: "Artist Previous Sponsorships",
  ACTIONLABEL: "Artist Previous Sponsorships",
  EXPORT_FILE_NAME: "Previous Sponses",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const FLASH_MESSAGE_DETAILS = {
  TITLE: "Flash Message",
  ACTIONLABEL: "Flash Message",
  EXPORT_FILE_NAME: "Flash Message",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}

export const EVENT_REQUEST_ARTIST_ASSOCIATIONS = {
  eventReqArtistAssocStateMap: {
    captions: {
      0: 'Not Requested',
      1: 'Confirmed',
      2: 'Pending',
      3: 'Rejected',
      4: 'Not Responded'
    },
    colors: {
      0: 'black',
      1: 'green',
      2: 'blue',
      3: 'red',
      4: 'gray'
    },
  }
}
export const CHAT_MESSAGE_DETAILS = {
  TITLE: "Chat Report",
  ACTIONLABEL: "Chat Report",
  EXPORT_FILE_NAME: "Chat Report",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}
export const OVERRIDE_ANSWER = {
  TITLE: "Overridden Responses",
  ACTIONLABEL: "Overridden Responses",
  EXPORT_FILE_NAME: "Overridden Responses",
  PAGESIZE: "15",
  PAGELIST: "10,15,20,30,40,50,100",
}